import { Group, Stack } from "@mantine/core"

import { OperationInfo } from "~/pages/SupplierPortal/TraceabilityRequests/components/OperationInfo.tsx"
import { useTraceabilityOperations } from "~/pages/SupplierPortal/TraceabilityRequests/context/useTraceabilityOperations"
import { useInformationRequestContext } from "~/pages/SupplierPortal/TraceabilityRequests/store/InformationRequestContext"
import { isOperationOwner } from "~/pages/SupplierPortal/TraceabilityRequests/utils.ts"

import { OperationFields } from "./OperationFields"
import { OperationNotOwner } from "./OperationNotOwner"

export const TraceabilityRequestOperation = () => {
  const { user, isRepresentedPartner } = useInformationRequestContext()
  const { operationItem } = useTraceabilityOperations()

  const isOwner =
    user && operationItem.operation
      ? isOperationOwner(operationItem.operation, user)
      : false
  const canEditOperation = isOwner || isRepresentedPartner

  return (
    <Group
      h="100%"
      align="flex-start"
      py="var(--tfg-organism-padding-y"
      px="var(--tfg-organism-padding-x)"
      w="100%"
      data-nodeid={operationItem.nodeId}
      bg={canEditOperation ? "white" : "gray.1"}
      pos="relative"
    >
      <Stack key={operationItem.nodeId} w="100%" justify="flex-start" h="100%">
        <Group align="flex-start" mb="md">
          <OperationInfo />
        </Group>
        {canEditOperation ? <OperationFields /> : <OperationNotOwner />}
      </Stack>
    </Group>
  )
}
